import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import TaskNavigation from "@components/Tasks/task-navigation";
import { getValue } from "@utils/lodash";
import { toast } from "react-toastify";
import moment from "moment";
import {
	addTaskComments,
	deleteTaskComments,
	getTaskComments,
	updateTaskComments,
} from "@services/task.service";
import Notfound from "@components/Not-Found";
import DeleteModal from "@_common/deleteModal";
import PaginationPage from "@components/pagination/pagination";
import Loader from "@components/common/Loader";
import _ from "lodash";
import { useCallbackPrompt } from "../../../../../../prompt/useCallbackPrompt";
import PromptModal from "../../../../../../prompt/modal";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { sanitizeInput } from "@_common/dompurify";

interface ITaskCommentsProps {}

const TaskComments: React.FunctionComponent<ITaskCommentsProps> = (
	props: any
) => {
	let navigate = useNavigate();
	let mainParams = useParams();
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */

	const [comments, setComments] = useState("");
	const [commentsDirty, setCommentsDirty] = useState("");

	const [loading, setLoading] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [allComments, setAllComments] = useState([]);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		if (props.permissionAPITriggered) getData();
	}, [props.permissionAPITriggered]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */
	const getData = async () => {
		try {
			let payload: any = {
				limit: limit,
				page_no: page_no,
				compliance_task_id: mainParams.taskId,
			};
			let queryRequest = QueryRequestHelper(payload);
			setLoading(true);
			let resp = await getTaskComments(queryRequest);
			if (resp) {
				setAllComments(getValue(resp, `data.comments`, []));
				setEdit(false);
				setEditId("");
				setLoading(false);
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
		}
	};
	const getDataRefetch = async () => {
		try {
			let payload: any = {
				limit: limit,
				page_no: page_no,
				compliance_task_id: mainParams.taskId,
			};
			let queryRequest = QueryRequestHelper(payload);
			// setLoading(true);
			let resp = await getTaskComments(queryRequest);
			if (resp) {
				setLoading(false);
				setAllComments(getValue(resp, `data.comments`, []));
				setEdit(false);
				setEditId("");
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
		}
	};

	const handleSubmit = async () => {
		if (editId) {
			try {
				setIsLoading(true);
				let payload = {
					comments: comments,
					// compliance_task_id: mainParams.taskId,
				};
				let resp = await updateTaskComments(editId, payload);
				if (resp) {
					confirmNavigation();
					toast.success("Updated successfully");
					setComments("");
					getDataRefetch();
					setEdit(false);
					setEditId("");
					setIsLoading(false);
				} else {
					setIsLoading(false);
				}
			} catch (error) {
				setIsLoading(false);
			}
		} else {
			try {
				setIsLoading(true);
				let payload = {
					comments: comments,
					compliance_task_id: mainParams.taskId,
				};
				let resp = await addTaskComments(payload);
				if (resp) {
					setIsLoading(false);
					confirmNavigation();
					toast.success("Updated successfully");
					setComments("");
					getDataRefetch();
				} else {
					setIsLoading(false);
				}
			} catch (error) {
				setIsLoading(false);
			}
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */
	const [edit, setEdit] = useState(false);
	const [editId, setEditId] = useState("");
	const handleEdit = (obj: object) => {
		setEditId(getValue(obj, `id`, ""));
		setComments(getValue(obj, `comments`, ""));
		setEdit(!edit);
	};
	const handleRemoveSelected = () => {
		setComments("");
		setEditId("");
	};

	/* -------------------------------------------------------------------------- */
	/*                               Pagination section                           */
	/* -------------------------------------------------------------------------- */

	const [totalCount, setTotalCount] = useState(0);
	const [limit, setLimit] = useState(10);
	const [page_no, setPage_no] = useState(1);

	const handleChangePagination = (page_no: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload = {
			...params,
			page_no: page_no,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const handleChangeLimit = (limit: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload:any = {
			...params,
			limit:limit,
			page_no:'1'
		}
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	/* -------------------------------------------------------------------------- */
	/*                                 Delete section                             */
	/* -------------------------------------------------------------------------- */

	const [deleteValue, setDeleteValue] = useState("");
	const [deleteId, setDeleteId] = useState("");
	const handleDeleteFun = (id: string, value: string) => {
		setDeleteValue(value);
		setDeleteId(id);
		handleDelete();
	};
	const [isDelete, setIsDelete] = useState(false);
	const handleDelete = () => {
		setIsDelete(!isDelete);
	};

	const handleDeleteFunction = async () => {
		try {
			let resp = await deleteTaskComments(deleteId);
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				handleDelete();
				getData();
			}
		} catch (error) {}
	};
	/* -------------------------------------------------------------------------- */
	/*                                Prompt Section                              */
	/* -------------------------------------------------------------------------- */
	const [isChanged, setIsChanged] = useState(false);
	useEffect(() => {
		setIsChanged(
			_.isEqualWith(comments, commentsDirty, (a: any, b: any) => {
				// if both are null or equal to an empty string then they are equal
				if ((_.isNull(a) || a === "") && (_.isNull(b) || b === "")) return true;
			})
		);
	});
	const [showPrompt, confirmNavigation, cancelNavigation]: any =
		useCallbackPrompt(!isChanged);

	return (
		<Layout>
			{!loading &&
			!getValue(props, `subTabPermissionList`, []).includes("activities_pe_compliance") ? (
				<NoAccessPage />
			) : (
				<>
					<PromptModal
						showDialog={showPrompt}
						confirmNavigation={confirmNavigation}
						cancelNavigation={cancelNavigation}
					/>
					<TaskNavigation
						id={mainParams.id}
						taskId={mainParams.taskId}
						checkpoint_id={mainParams.checkpoint_id}
						firstDay={mainParams.firstDay}
						lastDay={mainParams.lastDay}
						locationId={mainParams.locationId}
						functionId={mainParams.functionId}
					/>
					<div className="comments-popup m-5">
						<div className="d-flex align-items-start justify-content-between w-100 mb-3">
							{getValue(props, `vendorInfo.vendor.vendor_name`, "")
								.charAt(0)
								.toUpperCase()}
							{/* </div> */}
							<textarea
								placeholder={"Add a comment"}
								value={comments}
								// onBlur={(e: ChangeEvent<HTMLInputElement>) =>
								//   setComments(e.target.value)
								// }
								onChange={(e) => setComments(sanitizeInput(e.target.value))}
								className="comments-popup__form-control form-control"
							/>
						</div>
						{getValue(props, `permissions`, []).includes("update") && (
							<div className="d-flex justify-content-end">
								<button
									className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
									onClick={() => handleRemoveSelected()}
									disabled={!comments}
								>
									Clear
								</button>
								{isLoading ? (
									<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
										Please wait...
									</button>
								) : (
									<button
										className={`ascent-button ascent-button--header-buttons ascent-button--${
											!isChanged ? "secondary" : "primary"
										}`}
										onClick={handleSubmit}
										disabled={!comments || isChanged}
									>
										{editId ? "Update" : "Submit"}
									</button>
								)}
							</div>
						)}
						<div>
							{loading || !props.permissionAPITriggered ? (
								<Loader />
							) : getValue(allComments, `length`, 0) > 0 ? (
								allComments.map((item: object) => {
									let user = JSON.parse(getValue(localStorage, `user`, {}));
									return (
										<div className="comments-popup-wrapper__comments">
											<div>
												<div className="d-flex align-items-start mb-3">
													<div className="d-flex comments-popup-wrapper__comments-wrapper">
														<div className="comments-popup-wrapper__comments-title-color">
															{getValue(item, `created_by.first_name`, "")
																.charAt(0)
																.toUpperCase()}
															{getValue(item, `created_by.last_name`, "")
																.charAt(0)
																.toUpperCase()}
														</div>
														{/* <img
														src="/images/pexels-jigar-maru-2085739/persoon-icon.png"
														className="img-fluid"
														height={36}
														width={36}
													/> */}
													</div>
													<div className="mx-3">
														<div className="d-flex align-items-center">
															<div>
																<h3 className="comments-popup-wrapper__comments-title ">
																	{getValue(item, `created_by.first_name`, "")}{" "}
																	{getValue(item, `created_by.last_name`, "")}
																</h3>
															</div>
															{getValue(props, `permissions`, []).includes(
																"update"
															) &&
																getValue(user, `id`, "") ===
																	getValue(item, `created_by.id`, "") && (
																	<div className="mx-3">
																		<>
																			<ul className="d-flex align-items-center">
																				<li className="comments-popup-wrapper__comments-list-item">
																					<a
																						className="cursor-pointer"
																						onClick={() => handleEdit(item)}
																					>
																						Edit
																					</a>
																				</li>
																				<li className="comments-popup-wrapper__comments-list-item">
																					<a
																						className="cursor-pointer"
																						onClick={() =>
																							handleDeleteFun(
																								getValue(item, `id`, ""),
																								getValue(item, `comments`, "")
																							)
																						}
																					>
																						Delete
																					</a>
																				</li>
																			</ul>
																		</>
																	</div>
																)}
														</div>
														<p className="comments-popup-wrapper__comments-text mb-2">
															Posted on{" "}
															{moment(getValue(item, `created_at`, "")).format(
																"DD-MMM-YYYY, hh:mm a"
															)}
															{"  "}
														</p>
														<p className="comments-popup-wrapper__comeent-text comments-popup-wrapper__comeent-text--comment">
															{getValue(item, `comments`, "")}
														</p>
													</div>
												</div>
											</div>
										</div>
									);
								})
							) : (
								<Notfound />
							)}
						</div>
					</div>
					<DeleteModal
						isOpen={isDelete}
						handleModal={handleDelete}
						handleSubmit={handleDeleteFunction}
						deleteValue={deleteValue}
					/>
					<div className="footer-wrapper d-flex justify-content-between">
						{allComments.length > 0 && (
							<img
								src="/images/building-illustration.svg"
								className="img-fluid"
							/>
						)}
						{totalCount > 10 ? (
							<PaginationPage
								totalCount={totalCount}
								limit={limit}
								pageNumber={page_no}
								handleChangePagination={handleChangePagination}
								handleChangeLimit={handleChangeLimit}
							/>
						) : (
							<p className="show-rows-count mt-3 d-flex">
								Total Count:&nbsp;&nbsp;{" "}
								<p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
							</p>
						)}
					</div>
				</>
			)}
		</Layout>
	);
};

export default TaskComments;
